export enum EditorGroupEnum {
  CONTENT = 'block.edit.content',
  TRANSLATION = 'block.edit.translation',
  STYLE = 'block.edit.styling',
  COLOR = 'block.edit.color',
  GENERAL = 'block-settings.general'
}
